import { useState, type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import type { Locale } from '@fastnorth/i18next';
import { useApp } from '../../hooks/AppProvider';
import { DEFAULT_TIMEZONE_NAME } from '../../config/constants';
import { EVENT_PROGRESS_V2_POLL_INTERVAL_MS } from './constants';
import EventProgressV2Skeleton from './EventProgressV2.skeleton';
import RaceProgressPageContent from './components/RaceProgressPageContent';
import RaceProgressPageLayout from './components/RaceProgressPageLayout';
import eventProgressV2SkeletonRowCount from './utils/eventProgressV2SkeletonRowCount';

const EventProgressV2LoadingContent = (): ReactElement => {
  const { i18n } = useTranslation();
  const locale = i18n.language as Locale;
  const [{ event }] = useApp();
  const [pageTopElement, setPageTopElement] = useState<HTMLDivElement | null>(null);
  const timeZone: string = event?.location.timezone || DEFAULT_TIMEZONE_NAME;
  const timezoneShort: string | undefined = new Date()
    .toLocaleTimeString(locale, {
      timeZone,
      timeZoneName: 'short',
    })
    .split(' ')
    .pop();
  const skeletonRowCount: number = eventProgressV2SkeletonRowCount(event);

  return (
    <RaceProgressPageLayout
      eventName={event?.name ?? ''}
      onPageTopElementChange={setPageTopElement}>
      <RaceProgressPageContent
        overviewLoading
        pageTopElement={pageTopElement}
        raceDetailsFallback={<EventProgressV2Skeleton />}
        secondsUntilUpdate={EVENT_PROGRESS_V2_POLL_INTERVAL_MS / 1000}
        subEvents={[]}
        summarySkeletonRowCount={skeletonRowCount}
        testId="event-progress-v2-page"
        timeZone={timeZone}
        timezoneShort={timezoneShort}
      />
    </RaceProgressPageLayout>
  );
};

export default EventProgressV2LoadingContent;
